var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 60,
    viewBox: "0 0 34 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 0.3c1.4 0.2 1.6 0.5 2.2 1.1l26 26c0.6 0.6 0.6 0.8 0.8 1.1 0.6 1.4 0.3 3-0.8 4.1l-26 26c-2.8 2.6-8.8-1.4-5.3-5.3l23.4-23.4 -23.4-23.4c0 0-1.2-1.4-1.1-3 0.2-1.9 1.5-3.3 3.8-3.3 0.1 0 0.2 0 0.3 0Z"
  })));
};
export default SvgChevronRight;